module.exports = __webpack_public_path__ + "static/318411271_666024785193960_7166147818736642359_n.jpg-1671186393569_512-06aa01cd420ebfbf0629e79c70036f2c.webp";